import { render, staticRenderFns } from "./ViewDocumentRecived.vue?vue&type=template&id=09a399da&scoped=true"
import script from "./ViewDocumentRecived.vue?vue&type=script&lang=js"
export * from "./ViewDocumentRecived.vue?vue&type=script&lang=js"
import style0 from "./ViewDocumentRecived.vue?vue&type=style&index=0&id=09a399da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a399da",
  null
  
)

export default component.exports